import request from '../../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../../types/enums/request-enums';

export type ReassignWorkItemsRequest = {
    itemIds: number[];
    targetAssignee: string;
};

export type ReassignWorkItemsResponse = {
    success: boolean;
    message?: string;
    reassignedCount?: number;
};

const pickBool = (raw: Record<string, unknown>, key: string) =>
    Boolean(raw[key] ?? raw[key.charAt(0).toUpperCase() + key.slice(1)]);

const pickString = (raw: Record<string, unknown>, key: string) =>
    String(raw[key] ?? raw[key.charAt(0).toUpperCase() + key.slice(1)] ?? '');

const pickNumber = (raw: Record<string, unknown>, key: string) => {
    const value = raw[key] ?? raw[key.charAt(0).toUpperCase() + key.slice(1)];
    return value == null ? undefined : Number(value);
};

const Reassign = async (
    featureKey: string,
    data: ReassignWorkItemsRequest,
): Promise<ReassignWorkItemsResponse> => {
    const raw = (await request({
        url: ApiURL.Command.WorkAssignmentCommandURL.Reassign(featureKey),
        method: RequestType.POST,
        data: {
            itemIds: data.itemIds,
            targetAssignee: data.targetAssignee,
        },
    })) as Record<string, unknown>;

    return {
        success: pickBool(raw, 'success'),
        message: pickString(raw, 'message') || undefined,
        reassignedCount: pickNumber(raw, 'reassignedCount'),
    };
};

export const WorkAssignmentCommand = {
    Reassign,
};
